import Header from "../components/Header";
import Hero from "../components/Hero";
import Solution from "../components/Solution";
import TelegramControl from "../components/TelegramControl";
import Pricing from "../components/Pricing";
import About from "../components/About";
import Guarantee from "../components/Guarantee";
import Footer from "../components/Footer";
import { useEffect } from "react";

export default function Landing() {
  useEffect(() => {
    // scroll reveal semplice
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in");
          }
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div data-testid="landing-page" className="bg-brand-bg">
      <Header />
      <main>
        <Hero />
        <Solution />
        <TelegramControl />
        <Pricing />
        <About />
        <Guarantee />
      </main>
      <Footer />
    </div>
  );
}
